import Card from "./Card"
import SmallHeadingComponent from "./SmallHeadingComponent"
import Documentation from "../documentation/Documentation"
import DocumentationElement from "../documentation/DocumentationElement"

interface HelpSideNavProps {
    onSelect: (doc: DocumentationElement) => void
    selection: DocumentationElement
}

function HelpSideNav(props: HelpSideNavProps) {
    return (
        <Card width={400}>
            <div className={"flex flex-col space-y-4"}>
                <SmallHeadingComponent>Hilfe-Resourcen</SmallHeadingComponent>
                {Documentation.map((doc, idx) => (
                    <div
                        key={idx}
                        onClick={() => props.onSelect(doc)}
                        className={
                            "hover:bg-primary-100 border-white border hover:border-primary-200 p-3 cursor-pointer max-h-screen overflow-y-scroll rounded " +
                            (props.selection === doc
                                ? "bg-primary-100 border-primary-200"
                                : "")
                        }>
                        {doc.title}
                    </div>
                ))}
            </div>
        </Card>
    )
}

export default HelpSideNav
